const useChatCompletion = ({
  isExistingUser,
  questions,
  newUserQuestions,
  agentData,
  photoPreview,
  collectedAnswersRef,
  getAnswersMap,
  getFinalHairClass,
  formatProfileData,
  renderStepText,
  addAiMessage,
  dispatch,
  setCompletedNewUserFlow,
  setQuestionStep,
  fetchRecommendations,
}) => {
  const appendGeneratedResultSteps = () => {
    const sharedQuestions = newUserQuestions || questions

    const diagnosisStep = sharedQuestions.find(
      (step) => step.id === 'diagnosis',
    )

    const recommendationsStep = sharedQuestions.find(
      (step) => step.id === 'recommendations',
    )

    const answersMap = getAnswersMap()

    const isGuestFlow =
      answersMap?.existingUserAction === 'option_someone_else'

    const currentHairType = isGuestFlow
      ? getFinalHairClass(answersMap)
      : (
          getFinalHairClass(answersMap) ||
          agentData?.hair_type
        )

    // =====================================================
    // PROFILE + DIAGNOSIS INTRO
    // =====================================================

    addAiMessage({
      text: isGuestFlow
        ? renderStepText({
            id: 'someone_else_diagnosis',
            questionTemplate:
              'Thanks. I now have enough information to generate their hair profile and diagnosis.',
          })
        : renderStepText(diagnosisStep || {}),

      hairProfile: {
        userName: isGuestFlow
          ? 'Guest'
          : agentData?.agentFullName || 'User',

        userAvatar: isGuestFlow
          ? null
          : agentData?.agentProfilePicture,

        hairType: currentHairType || 'Unknown',

        profileItems: formatProfileData(answersMap),

        hairPhoto:
          collectedAnswersRef.current.find(
            (answer) =>
              answer.stepId === 'hair_photo' ||
              answer.stepId === 'someone_else_hair_photo',
          )?.photoUrl ||
          photoPreview ||
          null,
      },
    })

    // =====================================================
    // RECOMMENDATION INTRO
    // =====================================================

    addAiMessage({
    text: isGuestFlow
      ? renderStepText({
          id: 'someone_else_recommendations',
          questionTemplate:
            'Great news! Based on their hair profile and needs, here are their top 3 picks. Swipe to explore.',
        })
      : renderStepText(recommendationsStep || {}),
    })

    // =====================================================
    // LOAD PRODUCTS
    // =====================================================

    setTimeout(() => {
      fetchRecommendations({
        force: isExistingUser,
      })
    }, 800)
  }

  const completeQuestionFlow = () => {
    if (!isExistingUser) {
      dispatch(setCompletedNewUserFlow(true))
    }

    dispatch(setQuestionStep(questions.length))

    appendGeneratedResultSteps()
  }

  return {
    completeQuestionFlow,
  }
}

export default useChatCompletion